import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EmbeddedAlertComponent } from '../../../shared/embedded-alert/embedded-alert.component';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css'],
  imports: [CommonModule, EmbeddedAlertComponent, ReactiveFormsModule],
})
export class RecoverPasswordComponent implements OnInit {
  recoverForm!: FormGroup;
  error!: string | null;
  success!: string | null;
  changeSuccess: boolean = false;
  fetchingRecoveryToken: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.recoverForm = this.fb.group({
      email: ['', [
        Validators.required,
        Validators.email
      ]]
    });
  }

  onSubmit() {
    this.error = null;

    if (this.recoverForm.invalid) {
      this.error = 'Please enter a valid email';
      return;
    }

    const email = this.recoverForm.value.email;
    this.fetchingRecoveryToken = true;

    this.authService.requestPasswordRecovery(email).subscribe(
      (res) => {
        let timeoutMins: number = 0;
        if (res !== null) timeoutMins = <number>res;

        if (timeoutMins > 0) {
          this.changeSuccess = true;
          this.success = `A recovery link has been sent to the email provided. The recovery link is only valid for ${timeoutMins} minutes.`;
        }
        this.fetchingRecoveryToken = false;
      },
      (errorMessage: any) => {
        if (errorMessage) {
          this.fetchingRecoveryToken = false;
          this.error = 'Server error';
        }
      },
    );
  }
}
